import classNames from 'clsx';
import React from 'react';

import styles from './Nudge.scss';

interface Props {
  badgeContent: number;
}

const Nudge: React.FC<Props> = ({ badgeContent }) => (
  <div
    className={classNames(styles.nudge, {
      [styles.badgeText]: badgeContent > 9
    })}
  >
    {badgeContent > 99 ? '99' : badgeContent}
  </div>
);

export default Nudge;
